import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-99165242"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-developer-card__container" }
const _hoisted_2 = { class: "m-developer-card__content mt--12" }
const _hoisted_3 = { class: "m-developer-card__content-info" }
const _hoisted_4 = { class: "m-developer-card__content-icons" }

import { useAppStore } from '@/store/modules/app';

export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingMediumDeveloperCard',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_base_skeleton_loader = _resolveComponent("base-skeleton-loader")!
  const _component_base_card = _resolveComponent("base-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_base_card, { class: "m-developer-card" }, {
      default: _withCtx(() => [
        _createVNode(_component_base_skeleton_loader, { type: "img" }),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_base_skeleton_loader, {
            styles: {
            height: '20px',
            width: _unref(useAppStore)().getWindowWidth() > 600 ? '180px' : '100%',
          },
            class: "mb--5",
            type: "mediumText"
          }, null, 8, ["styles"]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", null, [
                _createVNode(_component_base_skeleton_loader, {
                  class: _normalizeClass(_unref(useAppStore)().getWindowWidth() > 600 ? 'mb--15' : 'mb--5'),
                  styles: {
                  width: _unref(useAppStore)().getWindowWidth() > 600 ? '130px' : '100px',
                },
                  type: "text"
                }, null, 8, ["class", "styles"]),
                _createVNode(_component_base_skeleton_loader, {
                  class: _normalizeClass(_unref(useAppStore)().getWindowWidth() > 600 ? 'mb--15' : 'mb--5'),
                  styles: {
                  width: _unref(useAppStore)().getWindowWidth() > 600 ? '130px' : '100px',
                },
                  type: "text"
                }, null, 8, ["class", "styles"]),
                _createVNode(_component_base_skeleton_loader, {
                  class: _normalizeClass(_unref(useAppStore)().getWindowWidth() > 600 ? 'mb--15' : 'mb--5'),
                  styles: {
                  width: _unref(useAppStore)().getWindowWidth() > 600 ? '130px' : '100px',
                },
                  type: "text"
                }, null, 8, ["class", "styles"])
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_base_skeleton_loader, {
                  class: _normalizeClass(_unref(useAppStore)().getWindowWidth() > 600 ? 'mb--15' : 'mb--5'),
                  styles: {
                  width: _unref(useAppStore)().getWindowWidth() > 600 ? '130px' : '100px',
                },
                  type: "text"
                }, null, 8, ["class", "styles"])
              ]),
              _createVNode(_component_base_skeleton_loader, {
                class: "none-Mobile",
                type: "btn"
              })
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_base_skeleton_loader, { type: "icon" }),
              _createVNode(_component_base_skeleton_loader, { type: "icon" })
            ])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})